import type { Components, Theme } from "@mui/material";

export const MuiAutocomplete: Components<Theme>["MuiAutocomplete"] = {
	styleOverrides: {
		root: ({ theme }) => ({
			"& .MuiOutlinedInput-root": {
				"& .MuiAutocomplete-endAdornment": {
					right: theme.spacing(1.5),
				},
			},
		}),
		paper: ({ theme }) => ({
			// Styles for the popup container
			borderRadius: theme.spacing(2),
			borderColor: theme.palette.border,
			borderStyle: "solid",
			borderWidth: 1,
			boxShadow: "1px 2px 8px 0 rgba(0, 0, 0, 0.1)",
			marginBottom: theme.spacing(1.5),
			marginTop: theme.spacing(0.5),
		}),
	},
};
